module.exports = __webpack_public_path__ + "static/media/loading.adb07677.svg";